import api from "./axios";


/*
|--------------------------------------------------------------------------
| SAMPLE ISSUES
|--------------------------------------------------------------------------
*/

export const getSampleIssues = async (
    page = 1,
    limit = 10,
    filters = {}
) => {

    const response = await api.get(
        "/sample-tracking/issues",
        {
            params: {
                page,
                limit,
                ...filters,
            },
        }
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| SINGLE ISSUE
|--------------------------------------------------------------------------
*/

export const getSampleIssue = async (
    id
) => {

    const response = await api.get(
        `/sample-tracking/issues/${id}`
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| CREATE
|--------------------------------------------------------------------------
*/

export const createSampleIssue = async (
    data
) => {

    const response = await api.post(
        "/sample-tracking/issues",
        data
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| UPDATE
|--------------------------------------------------------------------------
*/

export const updateSampleIssue = async (
    id,
    data
) => {

    const response = await api.patch(
        `/sample-tracking/issues/${id}`,
        data
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| CANCEL
|--------------------------------------------------------------------------
*/

export const cancelSampleIssue = async (
    id
) => {

    const response = await api.delete(
        `/sample-tracking/issues/${id}`
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| RETURNS
|--------------------------------------------------------------------------
*/

export const getSampleReturns = async (
    id
) => {

    const response = await api.get(
        `/sample-tracking/issues/${id}/returns`
    );

    return response.data;
};


export const createSampleReturn = async (
    id,
    data
) => {

    const response = await api.post(
        `/sample-tracking/issues/${id}/returns`,
        data
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| CONVERSIONS
|--------------------------------------------------------------------------
*/

export const getSampleConversions = async (
    id
) => {

    const response = await api.get(
        `/sample-tracking/issues/${id}/conversions`
    );

    return response.data;
};


export const createSampleConversion = async (
    id,
    data
) => {

    const response = await api.post(
        `/sample-tracking/issues/${id}/conversions`,
        data
    );

    return response.data;
};